import styled from '@emotion/styled';
import { Checkbox, Form, Tooltip } from 'antd';
import FormField from 'components/FormField';
import TransComponent from 'components/TransComponent';
import useMixingTokoText from 'hooks/business/useMixingTokoText';
import { set } from 'lodash-es';
import { Question } from '../PolicyForm';
import { DisabledProps, FV, PlatformProps, Validate } from './share';
import { FilterNegativeBuyer } from './FilterNegativeBuyer';
import useSmartField from 'hooks/useSmartField';
import { T, useTranslate } from '@tolgee/react';

const GreyWrapper = styled.div`
  padding: 14px 25px;
  background: #f0f2f5;
  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > h3 {
      font-size: 16px;
    }
  }
`;

const minAfterSaleConfirmDays = 0;
const maxAfterSaleConfirmDays = 366;

export const validate: Validate = (errors, values, t) => {
  const {
    filterAfterSale: { enable: filterAfterSaleEnable, confirmDays: filterAfterSaleConfirmDays },
  } = values;

  if (filterAfterSaleEnable) {
    if (!filterAfterSaleConfirmDays && filterAfterSaleConfirmDays !== 0) {
      set(errors, 'filterAfterSale.confirmDays', t('marketing.请输入买家确认收货天数'));
    } else if (
      filterAfterSaleConfirmDays > maxAfterSaleConfirmDays ||
      filterAfterSaleConfirmDays < minAfterSaleConfirmDays
    ) {
      set(
        errors,
        'filterAfterSale.confirmDays',
        t('marketing.请输入范围x-y的整数', {
          x: minAfterSaleConfirmDays,
          y: maxAfterSaleConfirmDays,
        }),
      );
    }
  }
};

export interface FilterAfterSaleFieldProps extends DisabledProps {
  scenarioType: Marketing.AllScenarioType;
  name?: string;
}

function FilterAfterSaleField(props: FilterAfterSaleFieldProps & PlatformProps) {
  const { scenarioType, platform, disabled = false, name = 'filterAfterSale' } = props;

  const { t } = useTranslate();

  const filterNegativeBuyer = useSmartField<FV['filterRule']['filterNegativeBuyer']>(
    'filterRule.filterNegativeBuyer',
  );

  const { filterRules } = useMixingTokoText();

  return (
    <FormField<FV['filterAfterSale']>
      name={name}
      label={
        <div>
          {t('aide.过滤规则')}
          <Tooltip
            title={
              <>
                <div>{filterRules.text}</div>
                <div>
                  {t('marketing.执行营销任务时，系统默认过滤存在未关闭订单和售后中订单的买家')}
                </div>
              </>
            }
          >
            <Question />
          </Tooltip>
        </div>
      }
    >
      {({ field: { value, onChange } }) => {
        return (
          <div>
            <Form.Item
              style={{
                marginBottom: 0,
              }}
            >
              <Checkbox
                disabled={disabled}
                checked={value.enable}
                onChange={(e) =>
                  onChange({
                    ...value,
                    enable: e.target.checked,
                  })
                }
              >
                {t('aide.售后买家')}
              </Checkbox>
            </Form.Item>
            {value.enable && (
              <GreyWrapper>
                <p>
                  <T
                    keyName="ai_order_remind_filter_after_sale_label"
                    params={{
                      x: <TransComponent content={<>90</>} />,
                    }}
                  />
                </p>
                <Checkbox
                  disabled={disabled}
                  checked={value.outOfOrderItem}
                  onChange={(e) =>
                    onChange({
                      ...value,
                      outOfOrderItem: e.target.checked,
                    })
                  }
                >
                  {t('ai_order_remind_filter_after_sale_checkbox')}
                </Checkbox>
              </GreyWrapper>
            )}
            <FilterNegativeBuyer
              platform={platform}
              className="mt-2"
              scenarioType={scenarioType}
              checked={filterNegativeBuyer.field.value}
              onChange={filterNegativeBuyer.field.onChange}
            />
          </div>
        );
      }}
    </FormField>
  );
}

export default FilterAfterSaleField;
